import React, { useState, useEffect, useRef } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../../../../components/tailwind-component/ui/card';
import { Button } from '../../../../../components/tailwind-component/ui/button';
import { Badge } from '../../../../../components/tailwind-component/ui/badge';
// import { Alert, AlertDescription } from '../../../../components/tailwind-component/ui/alert';
import { Instagram, CheckCircle2, AlertCircle, RefreshCw } from 'lucide-react';
import { PostManager } from './PostManager';
// import { toast } from 'sonner';
import { toast } from 'react-toastify';

import { PostWithAutomationMeta } from 'custom-type';
// import { HandlesService } from '../../../../core/services/handles.service';
import * as gtUtil from "../../../../../core/utility";
// import { UserService } from "../../../../core/services";
// import { connect } from 'react-redux';
// import { Loading, UserLogin } from "../../../../redux/action";
import InstagramIcon1 from '../../../../../components/icons/instagram-icon1';
import { InstagramDMAutomation } from "../../../../../core/services/dm-automation-instagram.service";
import { Tooltip } from '../../../../../components/tailwind-component/ui/tooltip';
import { IconButton } from '@mui/material';
import { InfoOutlined } from '@mui/icons-material';
import { DarkTooltip } from '../../../../../components/tailwind-component/ui/darkTooltip';
import { isUnlimitedEntitlement, limitAsNumber, formatEntitlementLimit } from '../../../../../core/utility';

const instagramDMAutomationService: InstagramDMAutomation = new InstagramDMAutomation();
// const handlesService = new HandlesService();
// const userService = new UserService();

interface AccountSettingsProps {
  // posts: PostWithAutomationMeta[];
  loading: (data: any) => any;
  influencerId: number;
  handleTogglePost: (ig_automation_id: number, ig_automation_post_id: number, status: boolean) => Promise<boolean>;
  handleDeletePost: (
    post: PostWithAutomationMeta,
    onPostDeleted: (postId: number) => void
  ) => void;
  // new props for pagination loading
  instagramConnect: () => void;
  connectingInstagram: boolean;
  setConnectingInstagram: React.Dispatch<
    React.SetStateAction<boolean>
  >;
  isConnected: boolean;
  connectedAccount: string;
  currentPlan: any;
  // Forwarded to PostManager's "How It Works" card so the Zap walkthrough is
  // reachable from the My Zaps tab too (modal state lives in ZapAutomations).
  onHowToUseZap?: () => void;
}

export function AccountSettings(props: AccountSettingsProps) {
  // posts data
  const [posts, setPosts] = useState<PostWithAutomationMeta[]>([]);

  // pagination states
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const loadMoreRef = useRef<HTMLDivElement | null>(null);
  const LIMIT = 5;
  // end pagination states
  const [activePosts, setActivePosts] = useState<number>(0);
  const [totalPosts, setTotalPosts] = useState<number>(0);

  // const [isConnected, setIsConnected] = useState<boolean>(false);
  // const [connectedAccount, setConnectedAccount] = useState<string>('@your_business_account');

  // const [social_loader, set_social_loader] = useState<boolean>(false);
  // const [stateToUpdateUserReducer, setStateToUpdateUserReducer] = useState<boolean>(false);
  // const [ig_data, set_ig_data] = useState({});

  // const [instagramAccount, setInstagramAccount] = React.useState<any>([]);
  // const [loadingInstagram, setLoadingInstagram] = React.useState(false);

  // const [socialRestrictionPopup, set_socialRestrictionPopup] = useState({
  //   // youtube: false,
  //   instagram: false
  // });

  // const handleConnect = () => {
  //   toast.info('Instagram connection requires OAuth authentication. This is a demo interface.');
  // };

  // const handleDisconnect = () => {
  //   toast.success('Account disconnected');
  // };

  // const handleSync = () => {
  //   toast.success('Syncing with Instagram...');
  // };

  // const instagramConnect = async () => {
  //   try {
  //     toast.success('Syncing with Instagram...');
  //     const response = await handlesService.instagramConnect();
  
  //     if (response.status === gtUtil.Constants.SUCCESS) {
  //       // Open Instagram OAuth in a popup window
  //       const popup = window.open(
  //         response.data.url,
  //         "InstagramOAuthPopup",
  //         "width=500,height=600,left=100,top=100"
  //       );
  
  //       if (!popup) {
  //         toast.error("Popup blocked. Please allow popups and try again.");
  //         return;
  //       }
  
  //       const channel = new BroadcastChannel('oauth-channel');
  //       channel.onmessage = async (event) => {
  //         if (event.data?.type === 'social-auth-success') {
  //           const authCode = event.data.code;
  //           channel.close();
  
  //           try {
  //             set_social_loader(true);
  
  //             // Send auth code to backend
  //             const response = await handlesService.postInstagramConnect({
  //               code: authCode,
  //               influencer_id: props?.UserReducer?.influencer_id
  //             });
  
  //             if (response.status === gtUtil.Constants.SUCCESS) {
  //               updateUserReducer();
  //               set_social_loader(false);
  //               // handleClosePopUps();
  //               // setPopUps({...popUps, openAdditionalSettingsModal: true});
  //             } else {
  //               if (response.info === 'Social account already connected to the other account.') {
  //                 set_ig_data(response.data);
  //                 set_socialRestrictionPopup(prevState => ({
  //                   ...prevState,
  //                   instagram: true
  //                 }));
  //               }
  //             }
  //           } catch (error) {
  //             console.error("Error processing Instagram auth response:", error);
  //             toast.error("Instagram authentication failed.");
  //           } finally {
  //             set_social_loader(false);
  //           }
  //         }
  //       };
  //     } else {
  //       console.error("Error fetching Instagram OAuth URL:", response.info);
  //       toast.error("Failed to get Instagram authentication URL.");
  //     }
  //   } catch (error) {
  //     console.error("Instagram Login Error:", error);
  //     toast.error("Instagram login failed");
  //   } finally {
  //     set_social_loader(false);
  //   }
  // };

  const handleSyncInstagram = async () => {
    if (!props?.influencerId || props.connectingInstagram) return;

    props.instagramConnect(); // DO NOT manage loader here
  };

  // async function updateUserReducer() {
  //   let latestUserReducerData = await userService.getUpdatedUserReducer(props.UserReducer);
  //   if (![undefined, null, ''].includes(latestUserReducerData)) {
  //     props.updateUser(latestUserReducerData)
  //   }
  //   // if (props.stateToUpdateUserReducerfuntion) {
  //   //   props.stateToUpdateUserReducerfuntion(!stateToUpdateUserReducer);
  //   // }
  //   setStateToUpdateUserReducer(!stateToUpdateUserReducer);
  // }

  // async function getInstagramAccounts() {
  //   try{
  //     setLoadingInstagram(true);
  //     handlesService
  //     .getConnectedInstagramAccounts(
  //       props?.UserReducer?.influencer_id
  //     )
  //     .then((res: any) => {
  //       if (res?.data?.rows.length > 0) {
  //         setInstagramAccount(res?.data?.rows);
  //         setConnectedAccount('@' + res?.data?.rows[0]?.username);
  //         setIsConnected(true);
  //       } else {
  //         setIsConnected(false);
  //       }
  //     })
  //     .catch((err: any) => {
  //       console.log(err)
  //       setLoadingInstagram(false);
  //       setIsConnected(false);
  //     })
  //   }catch(err){
  //     console.log(err)
  //     setLoadingInstagram(false)
  //   }finally{
  //     setLoadingInstagram(false)
  //   }
  // }

  // useEffect(() => {
  //   getInstagramAccounts();
  // }, []);

  // New fetch posts api
  async function fetchPosts(currentPage: number = 1) {
    // if (isLoading || !hasMore) return;
    if (isLoading) return;
    try {
      // props.loading(true);
      setIsLoading(true);

      // const currentPage = refresh ? 1 : page;

      const res = await instagramDMAutomationService.getIgAutomationsPosts({
        influencer_id: props.influencerId,
        page: currentPage,
        limit: LIMIT,
      });

      if (res.status === gtUtil.Constants.SUCCESS && Array.isArray(res.data?.rows)) {
        // setAutomations(res.data.rows);
        setPosts(prev => [...prev, ...res.data.rows]);

        setTotalPosts(res.data.rows[0].total_post || 0);
        setActivePosts(res.data.rows[0].active_post || 0);
        // setTotalPosts(res.data.rows[0].total_post);
        // Pagination logic
        if (res.data.rows.length < LIMIT) {
          setHasMore(false); // stop pagination
        } 
        else if (res.data.rows[0].total_post <= LIMIT) {
          setHasMore(false); // stop pagination
        }
        else {
          setPage(prev => prev + 1);
        }
      } else if (res.status === gtUtil.Constants.DB_QUERY_NO_RECORD_FOUND) {
        // setAutomations([]);
        setHasMore(false);
      }
    } catch (error) {
      console.error("Error fetching IG Automations:", error);
    } finally {
      props.loading(false);
      setIsLoading(false);
    }
  }

  const handleTogglePost = async (
    ig_automation_id: number,
    ig_automation_post_id: number,
    status: boolean
  ) => {
    try {
      const responseStatus: boolean = await props.handleTogglePost(ig_automation_id, ig_automation_post_id, status);
      if (responseStatus) {
        setPosts(prev => {
          const toggledPost = prev.find(
            post => post.ig_automation_post_id === ig_automation_post_id
          );

          if (!toggledPost) return prev;

          const wasActive = toggledPost.is_active;
          const willBeActive = status;

          // update active count safely
          if (wasActive && !willBeActive) {
            setActivePosts(p => Math.max(p - 1, 0));
          } else if (!wasActive && willBeActive) {
            setActivePosts(p => p + 1);
          }
          
          return prev.map(post =>
            post.ig_automation_post_id === ig_automation_post_id
              ? { ...post, is_active: status }
              : post
          )
        });
      }
    } catch (error) {
      console.error("Toggle error:", error);
      toast.error("Something went wrong");
    }
  };

  const handleDeletePost = (post: PostWithAutomationMeta) => {
    props.handleDeletePost(post, onPostDeleted);
  };

  const onPostDeleted = (deletedPostId: number) => {
    if (posts.length < LIMIT) {
      refreshAutomationPostList();
    } else {
      setPosts(prev => {
        const deletedPost = prev.find(
          post => post.ig_automation_post_id === deletedPostId
        );

        // update active count safely
        if (deletedPost?.is_active) {
          setActivePosts(p => Math.max(p - 1, 0));
        }

        // update total count
        // setTotalPosts(totalAutomations - 1);
        setTotalPosts(p => Math.max(p - 1, 0));
        
        return prev.filter(
          post => post.ig_automation_post_id !== deletedPostId
        )
      });
    }
  };

  useEffect(() => {
    if (!hasMore || isLoading) return;

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          fetchPosts(page);
        }
      },
      { threshold: 0.5 }
    );

    if (loadMoreRef.current) {
      observer.observe(loadMoreRef.current);
    }

    return () => {
      if (loadMoreRef.current) {
        observer.unobserve(loadMoreRef.current);
      }
    };
  }, [hasMore, isLoading]);

  const refreshAutomationPostList = async () => {
    setPosts([]);
    setTotalPosts(0);
    setActivePosts(0);
    setPage(1);
    setHasMore(true);
    fetchPosts();
    props.setConnectingInstagram(false);
  };

  useEffect(() => {
    refreshAutomationPostList();
  }, []);
  // const DMLimitPerDay = props.currentPlan.entitlements.daily_interaction_limit;
  // const triggerCountAddressed = props.currentPlan.utilizedInteractions.daily_interaction_utilized;

  // OLD (pre-unlimited): `|| 0` turned the -1 "Unlimited" sentinel into 0, which
  // made the meter read 0/-1 and pinned the colour to red.
  // const DMLimitPerDay = props.currentPlan?.entitlements?.daily_interaction_limit || 0;
  const rawDMLimitPerDay = props.currentPlan?.entitlements?.daily_interaction_limit ?? 0;
  const isDMLimitUnlimited = isUnlimitedEntitlement(rawDMLimitPerDay);
  const DMLimitPerDay = limitAsNumber(rawDMLimitPerDay, 0); // Infinity when unlimited
  const triggerCountAddressed = props.currentPlan?.utilizedInteractions?.daily_interaction_utilized || 0;

  const remaining = DMLimitPerDay - triggerCountAddressed;

  // OLD (pre-unlimited): const percentage = DMLimitPerDay > 0 ? (triggerCountAddressed / DMLimitPerDay) * 100 : 0;
  // An unlimited plan is never "consumed", so the meter stays green at 0%.
  const percentage = isDMLimitUnlimited
    ? 0
    : (DMLimitPerDay > 0 ? (triggerCountAddressed / DMLimitPerDay) * 100 : 0);

  let color = "#22c55e"; // green

  if (percentage >= 70 && percentage < 100) {
    color = "#eab308"; // yellow
  }

  if (percentage >= 100) {
    color = "#ef4444"; // red
  }
  
  const InstagramAccountSkeleton = () => {
    return (
      <Card className="animate-pulse">
        <CardContent className="space-y-4">
          <div className="flex flex-col gap-2 md:gap-0 md:flex-row md:items-center justify-between p-3 md:p-4 border rounded-lg">
            
            {/* Left section */}
            <div className="flex items-center gap-2 md:gap-3">
              {/* Instagram icon placeholder */}
              <div className="w-8 h-8 rounded-lg bg-gray-200" />

              <div className="space-y-2">
                {/* Account name */}
                <div className="h-4 w-32 bg-gray-200 rounded" />

                {/* Status badge */}
                <div className="h-5 w-20 bg-gray-200 rounded-full" />
              </div>
            </div>

            {/* Right section (buttons) */}
            <div className="flex gap-2 mt-2 md:mt-0">
              <div className="h-8 w-24 bg-gray-200 rounded" />
            </div>
          </div>
        </CardContent>
      </Card>
    );
  };

  return (
    <div className="space-y-6">
      {
        isLoading 
        ? 
        <InstagramAccountSkeleton />
        :
        <Card>
          {/* <CardHeader>
            <CardTitle>Instagram Account</CardTitle>
            <CardDescription>
              Connect your Instagram business account to enable automation
            </CardDescription>
          </CardHeader> */}
          <CardContent className="space-y-4">
            {/* <Alert>
              <AlertCircle className="h-4 w-4" />
              <AlertDescription>
                This is a demonstration interface. In production, you would need Instagram Business API access and proper OAuth authentication.
              </AlertDescription>
            </Alert> */}

            <div className="flex flex-col gap-2 md:gap-0 md:flex-row md:items-center justify-between p-3 md:p-4 border rounded-lg">
              <div className="flex items-center gap-2 md:gap-3" >
                <div className="bg-gradient-to-br from-purple-500 to-pink-500 p-0 rounded-lg mt-2">
                  <InstagramIcon1 className="w-2 h-4 md:w-4 text-white" />
                </div>
                <div>
                  <div className="flex items-center gap-2">
                    <span>{props.connectedAccount}</span>
                    {props.isConnected && (
                      <Badge variant="default" className="bg-green-500 z-0">
                        <CheckCircle2 className="w-3 h-3 mr-1" />
                        Connected
                      </Badge>
                    )}
                  </div>
                  {/* <p className="text-sm text-gray-500">Business Account</p> */}
                </div>
              </div>
              <div className="flex gap-2">
                {props.isConnected ? (
                  <>
                    {/* <Button variant="outline" size="sm" onClick={handleSync}>
                      <RefreshCw className="w-4 h-4 mr-2" />
                      Sync
                    </Button> */}
                    <Button variant="outline" size="sm" onClick={handleSyncInstagram}>
                      <RefreshCw className="w-4 h-4 mr-2" />
                      {props.connectingInstagram ? "Syncing" : "Sync"}
                    </Button>
                    {/* <Button variant="outline" size="sm" onClick={handleDisconnect}>
                      Disconnect
                    </Button> */}
                  </>
                ) : (
                  <Button onClick={handleSyncInstagram}>
                    <Instagram className="w-4 h-4 mr-2" />
                    {props.connectingInstagram ? "Connecting" : "Connect Account"}
                  </Button>
                )}
              </div>
            </div>
          </CardContent>
        </Card>
      }
      <Card>
        {/* <CardHeader>
          <CardTitle>Instagram Account</CardTitle>
          <CardDescription>
            Connect your Instagram business account to enable automation
          </CardDescription>
        </CardHeader> */}
        {/* <CardContent className="space-y-4 d-flex justify-between">
          <span className='fs-14 m-0'>Trigger Count: </span>
          <span className='d-flex items-center m-0'>
            <span className='fs-14 m-0'>{triggerCountAddressed}</span>
              <DarkTooltip
                title="Info"
                arrow
                placement="top"
                componentsProps={{
                  tooltip: {
                    sx: {
                      fontWeight: 300,
                      fontSize: 11,
                      letterSpacing:'0.5px'
                    },
                  },
                }}
                
              >
                <IconButton size="small" sx={{ padding: "2px" }}>
                  <InfoOutlined sx={{ fontSize: 16, color: "#9ca3af" }} />
                </IconButton>
              </DarkTooltip>
            </span>
        </CardContent> */}
        <CardContent className="space-y-4 d-flex justify-between">
          <span className="fs-14 m-0">Trigger Count: </span>

          <span className="d-flex items-center m-0">
            <span className="fs-14 m-0">{triggerCountAddressed}</span>

            <DarkTooltip
              arrow
              placement="top"
              componentsProps={{
                tooltip: {
                  sx: {
                    fontWeight: 300,
                    fontSize: 11,
                    letterSpacing: "0.5px",
                  },
                },
              }}
              title={
                <div>
                  {/* OLD (pre-unlimited):
                      {Math.min(triggerCountAddressed, DMLimitPerDay)}/{DMLimitPerDay} per day triggers addressed. */}
                  <span>
                    {isDMLimitUnlimited
                      ? `${triggerCountAddressed} triggers addressed (Unlimited).`
                      : `${Math.min(triggerCountAddressed, DMLimitPerDay)}/${DMLimitPerDay} per day triggers addressed.`}
                  </span>

                  {!isDMLimitUnlimited && triggerCountAddressed > DMLimitPerDay && (
                    <div style={{ marginTop: 6 }}>
                      {triggerCountAddressed - DMLimitPerDay} unaddressed interactions.{" "}
                      <span
                        style={{
                          color: "#60a5fa",
                          textDecoration: "underline",
                          cursor: "pointer",
                        }}
                      >
                        Upgrade
                      </span>
                    </div>
                  )}
                </div>
              }
            >
              <IconButton size="small" sx={{ padding: "2px" }}>
                <InfoOutlined sx={{ fontSize: 16, color: "#9ca3af" }} />
              </IconButton>
            </DarkTooltip>
          </span>
        </CardContent>
      </Card>
      
      {/* <PostManager posts={props.posts} handleTogglePost={props.handleTogglePost} handleDeletePost={props.handleDeletePost} isLoading={props.isLoading} hasMore={props.hasMore} loadMoreRef={props.loadMoreRef} total_post={props.total_post} getIgAutomationsList={props.getIgAutomationsList} page={props.page} /> */}
      <PostManager posts={posts} handleTogglePost={handleTogglePost} handleDeletePost={handleDeletePost} isLoading={isLoading} hasMore={hasMore} loadMoreRef={loadMoreRef} total_post={totalPosts} fetchPosts={fetchPosts} page={page} onHowToUseZap={props.onHowToUseZap} />

     
  <Card className="rounded-2xl border border-[#E5E7EB] bg-white p-4 md:p-6">
  <CardHeader className="p-0 mb-2   md:mb-6">
    <CardTitle>Zap Settings</CardTitle>

    <CardDescription className="text-[12px] md:text-[16px] text-[#6B7280]">
      Configure how your automation works
    </CardDescription>
  </CardHeader>

  <CardContent className="p-0">
    <div className="space-y-3 md:space-y-8">

      {/* Response Delay */}
      <div className="flex  items-start justify-between gap-3 md:gap-0">
        <div>
          <p className="text-[14px] md:text-[18px] font-semibold text-[#2B2B2B]">
            Response Delay
          </p>

          <p className="text-[12px] md:text-[15px] text-[#6B7280]">
            Wait time before sending DM
          </p>
        </div>

        <div className="rounded-md border border-[#E5E7EB] bg-white px-2 py-1 text-[11px] md:text-[13px] text-[#6B7280] whitespace-nowrap">
          5 seconds
        </div>
      </div>

      {/* Daily Limit */}
      <div className="flex  items-start justify-between gap-3 md:gap-0">
        <div>
          <p className="text-[14px] md:text-[18px] font-semibold text-[#2B2B2B]">
            Daily Limit
          </p>

          <p className="text-[12px] md:text-[15px] text-[#6B7280]">
            Maximum DMs per day
          </p>
        </div>

        {/* OLD: hardcoded "3000 messages" — it ignored the plan entirely, so it kept
            showing 3000 for every user (FOC included) and never reflected Unlimited.
            Now driven by the same daily_interaction_limit entitlement as the meter above. */}
        <div className="rounded-md border border-[#E5E7EB] bg-white px-2 py-1 text-[11px] md:text-[13px] text-[#6B7280] whitespace-nowrap">
          {isDMLimitUnlimited
            ? 'Unlimited'
            : `${formatEntitlementLimit(rawDMLimitPerDay)} messages`}
        </div>
      </div>

      {/* Keyword Matching */}
      <div className="flex  items-start justify-between gap-3 md:gap-0">
        <div>
          <p className="text-[14px] md:text-[18px] font-semibold text-[#2B2B2B]">
            Keyword Matching
          </p>

          <p className="text-[12px] md:text-[15px] text-[#6B7280]">
            How keywords are detected
          </p>
        </div>

        <div className="rounded-md border border-[#E5E7EB] bg-white px-2 py-1 text-[11px] md:text-[13px] text-[#6B7280] whitespace-nowrap">
          Exact match
        </div>
      </div>

    </div>
  </CardContent>
</Card>

      <Card>
        <CardHeader>
          <CardTitle>Requirements</CardTitle>
          <CardDescription>What you need to use this automation</CardDescription>
        </CardHeader>
        <CardContent>
          <ul className="space-y-2 text-sm">
            <li className="flex items-start gap-2">
              <CheckCircle2 className="w-4 h-4 text-green-500 mt-0.5" />
              <span>Instagram Business or Creator account</span>
            </li>
            <li className="flex items-start gap-2">
              <CheckCircle2 className="w-4 h-4 text-green-500 mt-0.5" />
              <span>Facebook Page connected to your Instagram account</span>
            </li>
            <li className="flex items-start gap-2">
              <CheckCircle2 className="w-4 h-4 text-green-500 mt-0.5" />
              <span>Instagram Graph API access</span>
            </li>
            <li className="flex items-start gap-2">
              <CheckCircle2 className="w-4 h-4 text-green-500 mt-0.5" />
              <span>Proper permissions for reading comments and sending messages</span>
            </li>
            {/* The one requirement the API cannot confirm. "Allow access to
                Messages" is an Instagram in-app toggle, not an OAuth scope, so it
                appears in none of the fields checkInstagramBusinessPermissions
                reads. It used to be an unconditional popup before every Zap; it
                sits here instead, marked amber rather than green because unlike
                the items above we genuinely do not know whether it is on. */}
            <li className="flex items-start gap-2">
              <AlertCircle className="w-4 h-4 text-amber-500 mt-0.5 shrink-0" />
              <span>
                <strong>&lsquo;Allow access to Messages&rsquo; turned on in the Instagram app.</strong>{' '}
                In Instagram: Menu &rsaquo; Settings and activity &rsaquo; Messages and story replies
                &rsaquo; Message Controls &rsaquo; Connected Tools. Instagram will not deliver your
                automated DMs while this is off, and it is the one setting we cannot check for you.
              </span>
            </li>
          </ul>
        </CardContent>
      </Card>
    </div>
  );
}